import {
  // PhoneSpecs,
  // possiblePhoneSizes,
  // possiblePhotographyPotentials,
  // PhotographyPotential,
  possiblePhoneCondensedConditions,
  PhoneCondensedCondition,
  PhoneSpecsCondensed,
} from '../phones'
import { Answers, Steps } from '../state/interfaces'

const containsFilters = (possibleFilters: string[], filtersToFind: string[]): boolean => {
  return possibleFilters.some((filter) => filtersToFind.includes(filter))
}

// const isPhonePhotograpyIncludedInAnswer = (phonePhotography: string | null, cameraFilter: string[]): boolean => {
//   const cameraFilterAllowanceMap = {
//     [PhotographyPotential.CRUCIAL as string]: [PhotographyPotential.CRUCIAL] as PhotographyPotential[],
//     [PhotographyPotential.IMPORTANT as string]: [
//       PhotographyPotential.IMPORTANT,
//       PhotographyPotential.CRUCIAL,
//     ] as PhotographyPotential[],
//     [PhotographyPotential.DONT_CARE as string]: [
//       null,
//       PhotographyPotential.DONT_CARE,
//       PhotographyPotential.IMPORTANT,
//       PhotographyPotential.CRUCIAL,
//     ] as PhotographyPotential[],
//   }

//   return cameraFilterAllowanceMap[cameraFilter[0]].includes(phonePhotography as PhotographyPotential)
// }

export const filterPhonesCondensed = (
  phones: Array<PhoneSpecsCondensed>,
  answers: Answers,
): Array<PhoneSpecsCondensed> => {
  const osFilters = answers[Steps.CHOOSE_PHONE_OS]
  // const memoryFilter = answers[Steps.CHOOSE_PHONE_MEMORY]
  // const sizeFilter = answers[Steps.CHOOSE_PHONE_SIZE]
  // const cameraFilter = answers[Steps.CHOOSE_PHONE_CAMERA]
  const phoneConditionFilter = answers[Steps.CHOOSE_PHONE_CONDITION]
  const brandFilters = [
    ...(answers[Steps.CHOOSE_PREFERRED_DEVICES_BRANDS] || []),
    ...(answers[Steps.CHOOSE_PREFERRED_DEVICES_BRANDS_ANDROID] || []),
    // ...(answers[Steps.CHOOSE_PREFERRED_DEVICES_BRANDS_PROPRIETARY] || []),
  ]
  const wifiCallingFilter = answers[Steps.CHOOSE_WIFI_CALLING]

  const filtersToApply: Array<(phoneCondensed: PhoneSpecsCondensed) => boolean> = []

  if (osFilters) {
    const osSlugs: string[] = []

    if (containsFilters(osFilters, ['ios', 'all'])) {
      osSlugs.push('ios')
    }

    if (containsFilters(osFilters, ['android', 'all'])) {
      osSlugs.push('android')
    }

    if (containsFilters(osFilters, ['proprietary', 'all'])) {
      osSlugs.push('proprietaryos')
    }

    filtersToApply.push((phone) => osSlugs.includes(phone.osSlug))
  }

  if (wifiCallingFilter) {
    if (containsFilters(wifiCallingFilter, ['yes'])) {
      filtersToApply.push((phone) => phone.hasWifiCalling)
    }
  }

  // if (memoryFilter) {
  //   let memoryLowerLimitInGb = 0
  //   let memoryUpperLimitInGb = 64
  //   if (containsFilters(memoryFilter, ['not-much'])) {
  //     filtersToApply.push(
  //       (phone) =>
  //         phone.modelMemorySize / 1000 > memoryLowerLimitInGb && phone.modelMemorySize / 1000 <= memoryUpperLimitInGb,
  //     )
  //   }
  //   if (containsFilters(memoryFilter, ['average'])) {
  //     memoryLowerLimitInGb = 64
  //     memoryUpperLimitInGb = 256
  //     filtersToApply.push(
  //       (phone) =>
  //         phone.modelMemorySize / 1000 >= memoryLowerLimitInGb && phone.modelMemorySize / 1000 <= memoryUpperLimitInGb,
  //     )
  //   } else if (containsFilters(memoryFilter, ['a-lot'])) {
  //     memoryUpperLimitInGb = 256
  //     filtersToApply.push((phone) => phone.modelMemorySize / 1000 >= memoryUpperLimitInGb)
  //   }
  // }

  // if (sizeFilter) {
  //   for (const size of possiblePhoneSizes) {
  //     if (containsFilters(sizeFilter, [size])) {
  //       filtersToApply.push((phone) => phone.size === size || !phone.size)
  //     }
  //   }
  // }

  // if (cameraFilter) {
  //   for (const photographyPotential of possiblePhotographyPotentials) {
  //     if (containsFilters(cameraFilter, [photographyPotential])) {
  //       filtersToApply.push((phone) => isPhonePhotograpyIncludedInAnswer(phone.photography, cameraFilter))
  //     }
  //   }
  // }

  if (phoneConditionFilter) {
    for (const condition of possiblePhoneCondensedConditions) {
      if (containsFilters(phoneConditionFilter, [condition])) {
        if (condition === PhoneCondensedCondition.REFURBISHED) {
          filtersToApply.push((phone) => phone.hasRefurbished === true)
        } else if (condition === PhoneCondensedCondition.NEW) {
          filtersToApply.push((phone) => phone.hasNew === true)
        }
      }
    }
  }

  if (brandFilters.length) {
    filtersToApply.push((phone) => brandFilters.includes(phone.brandSlug) || brandFilters.includes('all'))
  }

  return phones.filter((phone) =>
    filtersToApply.reduce((accumulator, currentFilter) => accumulator && currentFilter(phone), Boolean(true)),
  )
}
